<template>
  <div>
    <p class="source-sans-3 font-bold text-[1.25rem] leading-[2rem] mb-[4px] sm:mb-[8px]">
      {{ title }}
    </p>
    <p class="box-border border-l-[4px] border-[#4D5766B2] px-[20px] py-[8px] whitespace-pre-line">
      <span
        class="text-[1.1875rem] sm:text-[1.25rem] leading-[1.75rem] sm:leading-[1.875rem] italic"
        >{{ quote }}</span
      >
    </p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    quote: {
      type: String,
      required: true,
    },
  },
};
</script>
